import StartCheckin from '../../../../components/StartCheckin/StartCheckin';

export default function StartCheckinPage() {
  return <StartCheckin></StartCheckin>;
}
